import React from 'react';
import { getClasificacion, getPropsTypeOfPackage, translate } from "../../utils/Common";
import * as BiIcons from 'react-icons/bi';
import { FaBox, FaUndo } from 'react-icons/fa';
import Button from '../common/Button';
import styles from './ItemReserva.module.css';

const ItemReserva = ({ index, showBox, item, setSelectedItem, itemName }) => {
    const isReservations = itemName === translate("global.reservations");
    const typeInfo = item?.IdTipoPaquete != null ? getPropsTypeOfPackage(item.IdTipoPaquete) : null;
    const isReturnType = item?.IdTipoPaquete === 3;

    return (
        <div className={styles.card}>
            <div className={`${styles.cardInner} ${item.Identificacion ? styles.withDoor : ''}`}>
                <div className={styles.header}>
                    <p className={styles.headerNumber}>Nro. {index + 1}</p>
                    {item.Identificacion && (
                        <div className={styles.doorBadge}>
                            <BiIcons.BiDoorOpen size={20} aria-hidden />
                            {item.Identificacion}
                        </div>
                    )}
                </div>
                {showBox && (
                    <div className={styles.boxWrapper}>
                        <img src="/img/box.png" alt="boxit-box" width="80" height="80" />
                    </div>
                )}
                <div className={styles.body}>
                    <p className={styles.packageLabel}>{translate("global.numPackage")}:</p>
                    <p className={styles.dropOffCode}>
                        {item.NumeroIdentificacion ?? ''}
                    </p>
                    <p className={styles.line}>
                        <span className={styles.lineLabel}>{translate("global.numTracking")}:</span>{' '}
                        {item.NumeroTracking ?? ''}
                    </p>
                    <p className={styles.line}>
                        <span className={styles.lineLabel}>{translate("global.client")}:</span>{' '}
                        <span className={styles.clientHighlight}>
                            {item.IdTipoUsuario !== 1
                                ? item.Email
                                : `${item.Cliente} (B${item.IdCliente})`}
                        </span>
                    </p>
                    {isReservations && (
                        <p className={styles.line}>
                            <span className={styles.lineLabel}>{translate("global.size")}:</span>{' '}
                            {item.Clasificacion ? getClasificacion(item.Clasificacion) : ''}
                        </p>
                    )}
                    <p className={styles.line}>
                        <span className={styles.lineLabel}>{translate("global.typeOfPackage")}:</span>{' '}
                        <span className={`${styles.typeBadge} ${isReturnType ? styles.typeBadgeReturn : styles.typeBadgePickup}`}>
                            {typeInfo?.icon}
                            {typeInfo?.text ? translate(typeInfo.text) : ''}
                        </span>
                    </p>
                    <div className={styles.locationBlock}>
                        <p className={styles.locationLabel}>{translate("global.ubication")}:</p>
                        <p className={styles.locationValue}>{item.Direccion ?? ''}</p>
                    </div>
                </div>
                {item.IsBoxit && (
                    <div className={`${styles.actions} ${!isReservations ? styles.withMargin : ''}`}>
                        {isReservations ? (
                            <Button
                                type="button"
                                size="sm"
                                variant="primary"
                                onClick={() => setSelectedItem(item)}
                                leftIcon={<BiIcons.BiDoorOpen size={18} aria-hidden />}
                            >
                                {translate("global.reserve")}
                            </Button>
                        ) : (
                            <Button
                                type="button"
                                size="sm"
                                variant="outline"
                                onClick={() => setSelectedItem(item)}
                                leftIcon={<BiIcons.BiDoorOpen size={18} aria-hidden />}
                            >
                                {translate("global.cancel")}
                            </Button>
                        )}
                    </div>
                )}
            </div>
        </div>
    );
};

export default ItemReserva;
